import React from 'react';
import { Intent, Icon } from '@blueprintjs/core';
import './empty-data.scss';

type Props = {
  message: string,
}

const EmptyData = ({
  message,
}:Props) => {

  return (
    <div className="empty-data">
      <Icon icon="error" intent={Intent.NONE} className="empty-data-icon" />
      <p className="empty-data-message">
        {message}
      </p>
    </div>
  )
}

export default EmptyData
